import React, { FC } from 'react';

import { Button } from '../../../../../../../button';
import { Modal } from '../../../../../../../modal/modal.component';
import { ModalIds } from '../../../../../../../../contexts/modals/modals.types';
import { RequestProps } from './request.types';
import { Typography } from '../../../../../../../../../../../components';
import styles from './request.module.scss';
import { useTranslation } from 'react-i18next';

/**
 * Request component
 * @description Content for the AutomatedOrdersConfirmation Edit flow Request stage
 *
 * @author Oleksii Medvediev
 * @param { RequestProps } props - RequestProps defined in the './request.types.ts'
 * @category Components
 */
const Request: FC<RequestProps> = ({ onSubmit, periodLabel }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'management' });

  return (
    <Modal
      modalId={ModalIds.automatedOrdersConfirmationEdit}
      title={t('modals.automatedOrdersConfirmation.edit.request.title')}
    >
      <div className={styles.wrapper}>
        <Typography.Text variant={'bodyText5'}>
          {t('modals.automatedOrdersConfirmation.edit.request.text', { periodLabel })}
        </Typography.Text>
        <div className={styles.controls}>
          <Button type={'button'} variant={'outline'} size={'large'} onClick={() => onSubmit('cancel')}>
            <Typography.Text variant={'bodyText2'}>
              {t('modals.automatedOrdersConfirmation.edit.request.cancel')}
            </Typography.Text>
          </Button>
          <Button type={'button'} variant={'main'} size={'large'} onClick={() => onSubmit('change')}>
            <Typography.Text variant={'bodyText2'}>
              {t('modals.automatedOrdersConfirmation.edit.request.change')}
            </Typography.Text>
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export { Request };
